import type { AssistantApi } from "~/components/assistant/api/AssistantApi";
import { readStreamEvents } from "~/components/assistant/lib/streamReader";

export interface StreamController {
  conversationId: string;
  abortController: AbortController;
  /** Set to true immediately when user requests cancellation */
  cancelRequested: boolean;
}

export async function* runStream(
  conversationId: string,
  api: AssistantApi,
  params: { prompt: string; servers: string[]; contextId: string },
  abortSignal?: AbortSignal
): AsyncGenerator<any, void, unknown> {
  const response = await api.sendMessage(conversationId, params);

  for await (const event of readStreamEvents(response, abortSignal)) {
    yield event;
  }
}
